import {RestrictedRouteModuleConfiguration} from "../router/model/UserPermission";
import {UserGranredAuthorityName} from "../router/const/AllPermitions";
import {
    BrandServiceModuleName,
    CustomerListModuleName,
    CustomerServiceModuleName,
    IMAGE_CROPPER_MODULE_NAME,
    ThemeColourPickerModuleName,
    USERS_MODULE_NAME,
    UserServiceModuleName
} from "../utils/names/optionalModuleNames";
import {USERS_CONTROLLER_NAME} from "../utils/names/controllerNames";
import {NavigationAccessRoles, NavigationItem} from "../main/model/navigationItem";
import {AngularJsMaterialModuleName} from "../utils/names/requiredModulesNames";
import {LoggedInUserResolver} from "./resolver/LoggedInUserResolver";
import {getTabName} from "modules/utils/TabNameUtils";

export const UsersModuleConfiguration = new RestrictedRouteModuleConfiguration(
    UserGranredAuthorityName.USERS,
    [
        USERS_MODULE_NAME,
        CustomerListModuleName,
        CustomerServiceModuleName,
        AngularJsMaterialModuleName,
        ThemeColourPickerModuleName,
        UserServiceModuleName,
        BrandServiceModuleName,
        IMAGE_CROPPER_MODULE_NAME],
    [
        ['/users', {
            template: require("./route/Users.html"),
            controller: USERS_CONTROLLER_NAME,
            controllerAs: '$ctrl',
            resolve: {
                loggedInUser: LoggedInUserResolver.instance
            }
        }]
    ],
    [new NavigationItem({
        title: "Users",
        href: "#!users",
        accessRole: [NavigationAccessRoles.ROLE_ADMIN],
        activeFunction: routeName => routeName.indexOf('users') != -1,
    })],
    [USERS_MODULE_NAME],
    [UserGranredAuthorityName.USERS],
    getTabName() + '| Users'
);

export default UsersModuleConfiguration;